import { gql } from '@apollo/client';

export const CALLBACK = gql`
  query CallbackQuery($contextId: String!) {
    context(contextId: $contextId) {
      callback {
        enabled
        buttons {
          label
          value
        }
      }
    }
  }
`;

export const LISTINGS = gql`
  query ListingsQuery($contextId: String) {
    listings(contextId: $contextId) {
      id
      uuid
      description
      location {
        full_address: locationString
        street
        postal_code: postalCode
        city
        country_short: country
        location {
          lat
          lng
        }
        timezone
      }
      title
    }
  }
`;

export const SUBJECTS = gql`
  query SubjectsQuery($listingId: String, $leadSegmentId: String) {
    subjects(listingId: $listingId, leadSegmentId: $leadSegmentId) {
      id
      description
      title
      order
      category {
        name
        order
      }
    }
  }
`;

export const MEETING_TYPES = gql`
  query MeetingTypesQuery(
    $subjectId: String!
    $listingId: String
    $leadSegmentId: String!
  ) {
    meetingTypes(
      subjectId: $subjectId
      listingId: $listingId
      leadSegmentId: $leadSegmentId
    ) {
      defaultAddressKey
      title
      label
      maxConcurrentTimetables
    }
  }
`;

export const OFFICES = gql`
  query OfficesQuery(
    $coordinates: GeoInput
    $location: LocationInput
    $subjectId: String!
    $listingId: String
    $meetingType: MeetingTypeLabel!
    $filters: [FilterInput!]
  ) {
    offices(
      coordinates: $coordinates
      location: $location
      listingId: $listingId
      subjectId: $subjectId
      meetingType: $meetingType
      filters: $filters
    ) {
      id
      active
      distance
      virtual
      timezone
      location
      title
    }
  }
`;

export const CONTACTS = gql`
  query ContactsQuery(
    $officeId: String!
    $subjectId: String!
    $listingId: String
    $limit: Int
    $offset: Int
  ) {
    contacts(
      officeId: $officeId
      subjectId: $subjectId
      listingId: $listingId
      limit: $limit
      offset: $offset
    ) {
      contacts {
        id
        fullName
        firstName
        lastName
        position
        profilePicture
      }
      total
      currentPage
      lastPage
    }
  }
`;

export const TIME_TABLE = gql`
  query Timetable($timetableInput: TimetableInput!) {
    timetable(input: $timetableInput) {
      columnAmount
      endDate
      startDate
      warnings {
        code
        message
      }
      groups {
        title
        endTime
        startTime
        rows {
          endDate
          startDate
          followsPreviousRow
          columns {
            contacts
            endDate
            key
            open
            startDate
          }
        }
      }
    }
  }
`;
